import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home/Home";
import TransactionPage from "./Pages/TransactionPage/TransactionPage"; 
import Dashboard from "./Pages/Dashboard/Dashboard";
import Login from "./Pages/Login/Login";
import Register from "./Pages/Register/Register";
import Bantuan from "./Pages/Bantuan/Bantuan";
import PoinPage from "./Pages/PoinPage/Poinpage";
import AnggaranPage from "./Pages/AnggaranPage/AnggaranPage";
import ProtectedRoute from "./Component/ProtectedRoute/ProtectedRoute";
import Akun from "./Pages/Akun/akun";
import Chatbot from "./Component/Chatbot/Chatbot";
import AdminDashboard from "./Pages/AdminDashboard/AdminDashboard";

// import OAuthSuccess from "./Pages/Login/OathSuccess.js";

function App() {

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/transaction" element={<ProtectedRoute><TransactionPage /><Chatbot /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /><Chatbot /></ProtectedRoute>} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/bantuan" element={<ProtectedRoute><Bantuan /><Chatbot /></ProtectedRoute>} />
          <Route path="/poin" element={<ProtectedRoute><PoinPage /><Chatbot /></ProtectedRoute>} />
          <Route path="/anggaran" element={<ProtectedRoute><AnggaranPage /><Chatbot /></ProtectedRoute>} />
          <Route path="/akun" element={<ProtectedRoute><Akun /><Chatbot /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /><Chatbot /></ProtectedRoute>} />
          {/* <Route path="/oauth-success" element={<OAuthSuccess />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;